export default __webpack_public_path__ + "static/media/banner_mis_lentes.dac32e7c.png";